export default "__VITE_ASSET__C4enjcB5__"